import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MASKS } from 'ng-brazil';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { BeneficioValor } from 'src/app/models/BeneficioValor';
import { Colaborador } from 'src/app/models/colaborador';
import { CollaboratorDetailsModel } from 'src/app/models/CollaboratorDetailsModel';
import { ResgatarBeneficioModel } from 'src/app/models/ResgatarBeneficioModel';
import { ResgateModel } from 'src/app/models/resgate-model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { SaldoCedenteService } from 'src/app/services/saldo-cedente.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
    selector: 'app-resgate-beneficio',
    templateUrl: './resgate-beneficio.component.html',
    styleUrls: ['./resgate-beneficio.component.css']
})
export class ResgateBeneficioComponent implements OnInit, OnDestroy {
    private routeSubscription: Subscription;
    private colaboradorID: number;
    private currentUser: Auth;
    private beneficioValorSelecionado: BeneficioValor;
    public observacaoSelecionada: string;

    public MASKS = MASKS;
    public collaboratorDetailsModel: CollaboratorDetailsModel
    public colaborador: Colaborador;
    public historicoResgate: ResgateModel[] = [];
    protected message: string;

    public justifyCtrl: FormControl = new FormControl();
    public justificativa: any;
    public valueCtrl: FormControl = new FormControl();
    public valor: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private colaboradorService: ColaboradorService,
        private authenticationService: AuthenticationService,
        private modalService: NgbModal,
        private pedidoService: PedidoService,
        private alertService: NewAlertService,
        private saldoCedenteService: SaldoCedenteService) {

        this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
            this.colaboradorID = + params.get('colaboradorID');
        });

        this.currentUser = this.authenticationService.currentUserValue;
    }

    ngOnInit() {
        this.colaboradorService.getById(this.colaboradorID, this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.colaborador = response.result;
                if(this.colaborador.pessoaGuid)
                    this.ObterDetalhes();
            }
        );

        this.ObterHistorico();
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    ObterHistorico() {
        this.pedidoService.ObterHistoricoResgate(this.colaboradorID, this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.historicoResgate = response.result;
                } else {
                    this.historicoResgate = [];
                }
            }, error => {
                this.alertService.error('Ocorreu um erro ao buscar os detalhes do favorecido');
            });
    }

    ObterDetalhes() {
        this.colaboradorService.GetDetails(this.colaborador.pessoaGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                this.collaboratorDetailsModel = response.result;
            }
        );
    }

    goToBack() {
        this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
    }

    ResgatarBeneficio(valor: string = null, observacao: string = null) {

        this.valor = this.valueCtrl.value;
        this.justificativa = this.justifyCtrl.value;
        valor = this.valueCtrl.value;
        observacao = this.justifyCtrl.value;

        this.message = '';
        //valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();

        if (!valor || +valor == 0 || +valor > this.beneficioValorSelecionado.valorBeneficio) {
            this.message = 'Valor inválido'
        }
        else if(!observacao){
            this.message = 'Digite uma justificativa'
        }
        else if(observacao.length < 3){
            this.message = 'Digite uma justificativa com mais detalhes'
        }
        else{
            let resgatarBeneficioModel = new ResgatarBeneficioModel();

            resgatarBeneficioModel.valor = +valor;
            resgatarBeneficioModel.cedenteGuid = this.currentUser.token.assignorGuid;
            resgatarBeneficioModel.gestorResponsavelResgateGuid = this.currentUser.token.userReferenceId;
            resgatarBeneficioModel.contaGuid = this.beneficioValorSelecionado.contaGuid;
            resgatarBeneficioModel.pessoaGuid = this.colaborador.pessoaGuid;
            resgatarBeneficioModel.observacao = observacao;

            this.pedidoService.ResgatarBeneficio(resgatarBeneficioModel).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {

                        this.collaboratorDetailsModel.currentProduct = response.result;
                        this.ObterHistorico();
                        this.alertService.success('Resgate realizado com sucesso');
                        this.modalService.dismissAll();
                        this.saldoCedenteService.updateBalance(this.currentUser.token.assignorGuid);
                        this.saldoCedenteService.updateCurrentAccountBalance(this.currentUser.token.assignorGuid);
                    }else{
                        if(response && response.message)
                            this.alertService.error(response.message);
                    }
                }
            );
        }
    }

    ShowModal(content: any, beneficioValor: BeneficioValor) {
        this.beneficioValorSelecionado = beneficioValor;
        this.valueCtrl.setValue(null);
        this.justifyCtrl.setValue(null);
        this.modalService.open(content, { centered: true });
    }

    OpenObservacao(content: any, observacao: string) {
        this.observacaoSelecionada = observacao;
        this.modalService.open(content, { centered: true });
    }

    ClearMessage(){
        this.message = '';
    }
}
